/**
 * The server's own explanation for a request it refused (4xx), else `fallback`. The API
 * answers an error as JSON `{ message }` (a salary sheet export's 422 says why tax could not
 * be worked out), but a proxy may answer with an HTML page or nothing at all, so this never
 * throws. A 5xx message describes the server's own fault (a database error, a TypeError),
 * which is no use to the person reading it, so that gets the fallback too.
 *
 * @param {Response} res A response that was not ok.
 * @param {string} fallback What to show when the server gives no usable reason.
 * @returns {Promise<string>}
 */
export const responseErrorMessage = async (res, fallback) => {
  if (!(res.status >= 400 && res.status < 500)) return fallback;
  try {
    const { message } = (await res.json()) || {};
    return typeof message === 'string' && message ? message : fallback;
  } catch {
    return fallback;
  }
};
